export default __webpack_public_path__ + "static/media/vector-pool-button.00759bfa.svg";